module.exports = __webpack_public_path__ + "img/9.cdd4cf92.png";